import React, { useEffect } from 'react'
import { BodyText, LeftSection, RightSection, SavingsHeader, SavingsWrapper } from '../savingsStage/SavingsStage.styles'
import { InvestmentColTwoSpanReverse, LeftColSection, RightColSection } from './AnnualSavings.styles'

export const AnnualSavings = () => {
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])
  return (
    <SavingsWrapper>
    <SavingsHeader>
          <LeftSection>
          <h3>
            Annual/One time savings designed
            For kids, managed by the parents
          </h3>
          </LeftSection>
          <RightSection>
              <img src="img/rafiki 4.svg" alt="humaan saving in a container" />
          </RightSection>
      </SavingsHeader>

      <InvestmentColTwoSpanReverse>
      <LeftColSection>
        <BodyText>
            This plan is similar in features to the Basic Savings plan
            but falls within the category of parents who can afford more 
            for their children, level up savings plan has no limit on deposit.
         

        </BodyText>
        <BodyText>
            A certain amount of money is been saved for the Child on a 
            monthly basis for a period of 12months, with which an Equity
            Syndicate Investment will be made on behalf of the child at 
            the end of the Savings period.

        </BodyText>
      </LeftColSection>

      <RightColSection>
          <img src="img/pixlr-bg-result (17).svg" alt="little girl child" />
      </RightColSection>
    </InvestmentColTwoSpanReverse>

  </SavingsWrapper>
  )
}
